import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { getData } from "../Api";
import { CartContext } from "../CartContext";
import Success from "./Success";
import { FaCheck } from "react-icons/fa";
import ReactPixel from "react-facebook-pixel";

const options = {
  autoConfig: true,
  debug: false,
};

ReactPixel.init("419304844367207", options);
ReactPixel.pageView();

function TrendingProducts() {
  const [trendingProducts, setTrendingProducts] = useState([]);
  const { addToCart } = useContext(CartContext);
  const [addedToCart, setAddedToCart] = useState({});

  // Toast
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getData("/trending-products");
        setTrendingProducts(response.data || []);
      } catch (error) {
        console.error("Error fetching trending products:", error);
        setTrendingProducts([]);
      }
    };

    fetchProducts();
  }, []);

  const handleAddToCart = (item) => {
    addToCart(item);

    setToastMessage(`${item.title} added to cart successfully!`);
    setShowToast(true);
    setAddedToCart((prev) => ({ ...prev, [item.id]: true }));

    ReactPixel.track("AddToCart", {
      content_ids: [item.id],
      content_type: "product",
      content_name: item.title,
      currency: "INR",
      value: item.discount_price,
    });
  };

  return (
    <>
      <section className="px-sm-5 py-5">
        <div className="text-center about-title mb-5">
          <h1 className="">
            फ्री डिलीवरी पाने के लिए 2 या अधिक कलरिंग बुक्स खरीदें
          </h1>
        </div>
        <div className="row">
          {trendingProducts.length > 0 ? (
            trendingProducts.map((item) => (
              <div
                key={item.id}
                className="col-xl-3 col-lg-4 col-6 mb-md-4 mb-md-3 mb-3"
              >
                <div className="product-card">
                  <Link to={`/product/${item.slug}`} className="linktext">
                    <div>
                      <img
                        src={`${item.image}`}
                        className="product-image"
                        alt={item.title}
                      />
                    </div>
                    <h5 className="product-title">{item.title}</h5>
                    <p className="product-price">
                      {item.discount_price ? (
                        <>
                          <span className="text-dark discount-price me-2">
                            ₹{item.discount_price}
                          </span>
                          {/* <span className="original-price">₹{item.price}</span>  */}
                        </>
                      ) : (
                        <span className="discount-price">₹{item.price}</span>
                      )}
                    </p>
                  </Link>
                  <button
                    className="btn btn-cart"
                    onClick={() => handleAddToCart(item)}
                  >
                    {addedToCart[item.id] ? (
                      <>
                        <FaCheck size={16} className="me-1" /> Added
                      </>
                    ) : (
                      "Add To Cart"
                    )}
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center w-100">No trending products available</p>
          )}
        </div>

        <div className="text-center pt-5 w-100">
          <Link to="/all-products" className="btn-style1">
            View All Products
          </Link>
        </div>
      </section>

      {/* ✅ Pass props to Success component */}
      <Success
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
    </>
  );
}

export default TrendingProducts;
